export const STORY_ISSUE_TYPES = [
  { key: 'story_text', label: 'Story text is wrong or confusing' },
  { key: 'image', label: 'Image looks wrong or inappropriate' },
  { key: 'audio', label: 'Audio issue' },
  { key: 'inappropriate', label: 'Too scary or inappropriate for kids' },
  { key: 'factual', label: 'Educational or factual error' },
  { key: 'other', label: 'Other' },
];

export const LESSON_ISSUE_TYPES = [
  { key: 'confusing', label: 'Question or content is confusing' },
  { key: 'wrong_answer', label: 'Wrong answer marked as correct' },
  { key: 'age_mismatch', label: 'Content does not match the age group' },
  { key: 'image', label: 'Image or animation issue' },
  { key: 'factual', label: 'Educational or factual error' },
  { key: 'inappropriate', label: 'Inappropriate content' },
  { key: 'other', label: 'Other' },
];

function buildSubject({ contentType, contentTitle, issueLabel }) {
  return `[Explore Report] ${contentType}: ${contentTitle} — ${issueLabel}`;
}

function buildBodyLines({
  contentTitle,
  contentType,
  character,
  worldId,
  position,
  issueLabel,
  issueDetail,
  reporterEmail,
  contentId,
}) {
  return [
    'Content report from Explore',
    '─────────────────────────────',
    `Content: ${contentTitle}`,
    `Type: ${contentType}`,
    ...(character ? [`Character: ${character}`] : []),
    ...(worldId ? [`World: ${worldId}`] : []),
    `Position: ${position}`,
    `Issue: ${issueLabel}`,
    '',
    'Additional comments:',
    issueDetail || '(add your comments here)',
    '',
    '─────────────────────────────',
    'App: Explore by Kiddoware',
    `Reported by: ${reporterEmail}`,
    `Content ID: ${contentId}`,
  ];
}

export function openReportEmail(params) {
  const subject = buildSubject(params);
  const body = buildBodyLines(params).join('\n');
  const mailtoLink =
    `mailto:support@kiddoware.com` +
    `?subject=${encodeURIComponent(subject)}` +
    `&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoLink;
}

/** Returns a plain-text string suitable for pasting into any web mail compose window. */
export function buildReportClipboard(params) {
  const subject = buildSubject(params);
  const body = buildBodyLines(params).join('\n');
  return [
    `To: support@kiddoware.com`,
    `Subject: ${subject}`,
    '',
    body,
  ].join('\n');
}
